import React, { useEffect, useState } from 'react'
import ToggleSwitch from '../../../Components/ToggleSwitch';
import { NetworkManager } from '../../../Components/NetworkManager';
import CreatableSelect from 'react-select/creatable';
import AttributeCountTable from './AttributeCountTable';
import TyreFields from './TyreFields';
import ReeferFields from './ReeferFields';
import StatusConfirmationFields from './StatusConfirmationFields';

const defaultStatus = [{ label: "Pass", value: "Pass" }, { label: "Fail", value: "Fail" }];

const ProcessTypeSpecific = ({processType, onDataChange, isEdit, eData}: any) => {
  const [tyreBrand, setTyreBrand] = useState<any>([]);
  const [tyreSize, setTyreSize] = useState<any>([]);
  const [tyreDepth, setTyreDepth] = useState<any>([]);
  const [selectedTyreBrands, setSelectedTyreBrands] = useState<any>([]);
  const [selectedTyreSizes, setSelectedTyreSizes] = useState<any>([]);
  const [selectedTyreDepth, setSelectedTyreDepth] = useState<any>([]);
  const [tyreCondition, setTyreCondition] = useState<any>([]);
  const [tyreStatus, setTyreStatus] = useState<any>([]);
  const [lightTypes, setLightTypes] = useState<any>([]);
  const [reflectorStatus, setReflectorStatus] = useState<any>([]);
  const [multiStatus, setMultiStatus] = useState<any>([]);
  const [isValid, setIsValid] = useState<any>(false);
  const [attributeCounts, setAttributeCounts] = useState<any>([
    { attributeName: "Tread Depth", count: 2 },
    { attributeName: "Brake %", count: 1 }
  ]);
  const [toggles, setToggles] = useState<any>({
    isStatusConfirmation: false,
    enableTyreBrands: false,
    enableTyreSizes: false,
    enableTyreDepth: false,
    enableTyreCondition: false,
    selectTyreStatus: false,
    repeatForAllTires: false,
    enableLightTypeCount: false,
    enableLightType: false,
    temperatureValue: false,
    hoursValue: false,
    presetValue: false,
    reflectorRequired: false,
    reflectorCountRequired: false
  });
  const [requiredTyreFields, setRequiredFields] = useState<any>({
    tyreBrandRequired: false,
    tyreSizeRequired: false,
    tyreDepthRequired: false,
    tyreConditionRequired: false,
    tyreStatusRequired: false,
  });
  
  useEffect(() => {
    if (isEdit === "task" && eData) {
      if(["General", "Light", "Reefer", "CTPAT", "Tire and Brakes"].includes(eData?.processType)){
        const status = eData?.multiStatus?.map((item: any) => {
            return { label: item, value: item };
          });
        setMultiStatus((prev: any) => (prev !== status ? status || [] : prev));
        if(eData?.processType === "Light"){
          const lightType = eData.lightTypes?.map((item: any) => {
            return {label: item, value: item};
          });
          setLightTypes((prev: any) => (prev !== lightType ? lightType || [] : prev));
          const reflecStatus = eData.reflectorStatus?.map((item: any) => {
            return {label: item, value: item};
          });
          setReflectorStatus((prev: any) => (prev !== reflecStatus ? reflecStatus || [] : prev));
        }
        if (eData?.processType === "Tire and Brakes") {
          const newAttributeCounts = [
             { attributeName: "Tread Depth", count: eData.tireThreadDepth !== undefined ? eData.tireThreadDepth : 2 },
             { attributeName: "Brake %", count: eData.brakes !== undefined ? eData.brakes : 1 }
          ];
          setAttributeCounts(newAttributeCounts);
        }
      }else if(eData?.processType === "Tyre" || eData?.processType === "Tire"){
        const brand = eData?.tyreDetails?.tyreBrands?.map((item: any) => {
          return { label: item?.brandName, value: item?.brandId };
        });
        const size = eData?.tyreDetails?.tyreSize?.map((item: any) => {
          return { label: item?.sizeName, value: item?.sizeId };
        });
        const depth = eData?.tyreDetails?.tyredepth?.map((item: any) => {
          return { label: item?.depthName, value: item?.depthId };
        });
        const condition = eData?.tyreDetails?.tyreCondition?.map((item: any) => {
          return { label: item, value: item };
        });
        const status = eData?.tyreDetails?.tyreStatus?.map((item: any) => {
          return { label: item, value: item };
        });
        setSelectedTyreBrands((prev: any) => (prev !== brand ? brand || [] : prev));
        setSelectedTyreSizes((prev: any) => (prev !== size ? size || [] : prev));
        setSelectedTyreDepth((prev: any) => (prev !== depth ? depth || [] : prev));
        setTyreCondition((prev: any) => (prev !== condition ? condition || [] : prev));
        setTyreStatus((prev: any) => (prev !== status ? status || [] : prev));
      }
      setToggles((prevToggles: any) => {
        const newToggles = {
          isStatusConfirmation: eData?.isStatusConfirmation || false,
          enableTyreBrands: eData?.tyreDetails?.tyreBrands !== null || false,
          enableTyreSizes: eData?.tyreDetails?.tyreSize !== null || false,
          enableTyreDepth: eData?.tyreDetails?.tyredepth !== null || false,
          enableTyreCondition: eData?.tyreDetails?.tyreCondition  !== null || false,
          selectTyreStatus: eData?.tyreDetails?.tyreStatus  !== null || false,
          repeatForAllTires: eData?.repeatForAllTires || false,
          enableLightTypeCount: eData?.enableLightTypeCount || false,
          enableLightType: eData?.enableLightType || false,
          temperatureValue: eData?.temperatureValue || false,
          hoursValue: eData?.hoursValue || false,
          presetValue: eData?.presetValue || false,
          reflectorCountRequired: eData?.reflectorCountRequired,
          reflectorRequired: eData?.reflectorRequired,
        };
  
        if (JSON.stringify(prevToggles) === JSON.stringify(newToggles)) {
          return prevToggles;
        }
        return newToggles;
      });
      setRequiredFields((prevReqFields: any)=>{
        const newReqFields = {
          tyreBrandRequired: eData?.tyreDetails?.requiredTyreFields?.tyreBrandRequired,
          tyreSizeRequired: eData?.tyreDetails?.requiredTyreFields?.tyreSizeRequired,
          tyreDepthRequired: eData?.tyreDetails?.requiredTyreFields?.tyreDepthRequired,
          tyreConditionRequired: eData?.tyreDetails?.requiredTyreFields?.tyreConditionRequired,
          tyreStatusRequired: eData?.tyreDetails?.requiredTyreFields?.tyreStatusRequired
        };
  
        if (JSON.stringify(prevReqFields) === JSON.stringify(newReqFields)) {
          return prevReqFields;
        }
        return newReqFields;
      })
    }
  }, [isEdit, eData]);
  
  useEffect(() => {
    let isValid = false;

    if (processType === "Tyre" || processType === "Tire") {
      const tyreValid =
        toggles.enableTyreBrands ||
        toggles.enableTyreSizes ||
        toggles.enableTyreDepth ||
        (toggles.enableTyreCondition && tyreCondition.length > 0) ||
        (toggles.selectTyreStatus && tyreStatus.length > 0);

      isValid = tyreValid;
    }

    if (["General", "Light", "Reefer", "CTPAT", "Tire and Brakes"].includes(processType)) {
      if (processType === "Tire and Brakes") {
        isValid = true;
      } else {
        isValid = !toggles.isStatusConfirmation || (multiStatus && multiStatus.length > 0);
      }

      if (processType === "Light") {
        isValid = isValid && (!toggles.enableLightType || (lightTypes && lightTypes.length > 0));
        if (toggles.reflectorRequired && !(reflectorStatus && reflectorStatus.length > 0)) {
          isValid = false;
        }
      }
    }
    if (processType === "Picture") {
      isValid = true;
    }
    if (processType === "CTPAT") {
      setToggles((prevToggles: any) => ({
        ...prevToggles,
        isStatusConfirmation: true,
      }));
      setMultiStatus(defaultStatus);
    }

    setIsValid(isValid);

    if (!toggles.isStatusConfirmation && multiStatus.length > 0) {
      setMultiStatus([]);
    }else if (!toggles.enableLightType && lightTypes.length > 0) {
      setLightTypes([]);
    }else if (!toggles.selectTyreStatus && tyreStatus.length > 0) {
      setTyreStatus([]);
    }else if (!toggles.enableTyreCondition && tyreCondition.length > 0) {
      setTyreCondition([]);
    }else if (!toggles.reflectorRequired && reflectorStatus.length > 0) {
      setReflectorStatus([]);
    }
  }, [
    processType,
    toggles.enableTyreBrands,
    toggles.enableTyreSizes,
    toggles.enableTyreDepth,
    toggles.enableTyreCondition,
    toggles.selectTyreStatus,
    tyreCondition,
    tyreStatus,
    toggles.isStatusConfirmation,
    multiStatus,
    toggles.enableLightType,
    lightTypes,
    toggles.reflectorRequired,
    reflectorStatus,
  ]);

  useEffect(()=>{
    if(processType === "Tyre" || processType === "Tire"){
      getAvailableTyreBrands();
      getAvailableTyreSize();
      getAvailableTyreDepth();
      setSelectedTyreBrands([{ label: "All", value: 0 }])
      setSelectedTyreSizes([{ label: "All", value: 0 }])
      setSelectedTyreDepth([{ label: "All", value: 0 }])
    }
  }, [processType])
  
  const getAvailableTyreBrands = () =>{
    let api: string = "api/tyreMasterData/brands";
    NetworkManager.sendJsonRequest(api, "", "", "GET", true, (dataObj: any) =>{
      if (dataObj) {
        const resData = JSON.parse(dataObj);
        const updatedData = resData.map((item:any) => ({
          label: item.brand,
          value: item.brandId
        }));
        setTyreBrand(updatedData);
      }
    },
    onLoginError)
  };

  const handleRequiredChange = (key: string, value: boolean) => {
    setRequiredFields((prev: any) => ({ ...prev, [key]: value }));
  };

  const getAvailableTyreSize = () =>{
    let api: string = "api/tyreMasterData/sizes";
    NetworkManager.sendJsonRequest(api, "", "", "GET", true, (dataObj: any) =>{
      if (dataObj) {
        const resData = JSON.parse(dataObj);
        const updatedData = resData.map((item:any) => ({
          label: item.size,
          value: item.tyreSizeId
        }));
        setTyreSize(updatedData);
      }
    },
    onLoginError);
  };
  
  const getAvailableTyreDepth = () =>{
    let api: string = "api/tyreMasterData/depths";
    NetworkManager.sendJsonRequest(api, "", "", "GET", true, (dataObj: any) =>{
      if (dataObj) {
        const resData = JSON.parse(dataObj);
        const updatedData = resData.map((item:any) => ({
          label: item.tyreDepth,
          value: item.tyreDepthId
        }));
        setTyreDepth(updatedData);
      }
    },
    onLoginError);
  };

  const onLoginError = (err: any) => {
    console.log(err);
  };

  const handleToggleChange = (key: string, value: boolean) => {
    setToggles((prevState:any) => ({
      ...prevState,
      [key]: value,
    }));
  };
  
  useEffect(() => {
    const data = {
      ...toggles,
      ...(toggles.enableTyreBrands && { selectedTyreBrands }),
      ...(toggles.enableTyreSizes && { selectedTyreSizes }),
      ...(toggles.enableTyreDepth && { selectedTyreDepth }),
      ...(toggles.enableTyreCondition && { tyreCondition }),
      ...(toggles.selectTyreStatus && { tyreStatus }),
      ...(toggles.reflectorRequired && { reflectorStatus }),
      lightTypes,
      multiStatus,
      isValid,
      requiredTyreFields,
      attributeCounts,
    };

    const tireBrake = {...data, ...requiredTyreFields};

    console.log("tireBrake", tireBrake);
    
    onDataChange(data);
  }, [requiredTyreFields, reflectorStatus, isValid, toggles, tyreBrand, tyreSize, tyreDepth, selectedTyreBrands, selectedTyreSizes, selectedTyreDepth, tyreCondition, tyreStatus, lightTypes, multiStatus, attributeCounts]);


  const handleMultiSelectAll = (selectedOptions: any, type: any) => {
    if (selectedOptions.some((option: any) => option.value !== 0)) {
      selectedOptions = selectedOptions.filter((option: any) => option.value !== 0);
    } else if (selectedOptions.length === 0) {
      selectedOptions = [{ label: "All", value: 0 }];
    }
  
    if(type == "brand"){
      setSelectedTyreBrands(selectedOptions)
    }else if(type == "size"){
      setSelectedTyreSizes(selectedOptions)
    }else if(type == "depth"){
      setSelectedTyreDepth(selectedOptions)
    }
  };

  
  return (
    <div>
        {processType === "Tire and Brakes" && (
         <>
          <div className="alert alert-info mt-3 mb-0" role="alert" style={{ fontSize: '13px' }}>
             <b>Note:</b> Enabling this task will display an image of the trailer in the mobile application based on the equipment's axle configuration. The user will then be required to manually enter values as needed.
          </div>
          <AttributeCountTable data={attributeCounts} setData={setAttributeCounts} />
         </>
        )}
        {(processType === "Tyre" || processType === "Tire") && 
        (<TyreFields 
          toggles={toggles}
          handleToggleChange={handleToggleChange}
          requiredTyreFields={requiredTyreFields}
          handleRequiredChange={handleRequiredChange}
          selectedTyreBrands={selectedTyreBrands}
          handleMultiSelectAll={handleMultiSelectAll}
          tyreBrand={tyreBrand}
          selectedTyreSizes={selectedTyreSizes}
          tyreSize={tyreSize}
          selectedTyreDepth={selectedTyreDepth}
          tyreDepth={tyreDepth}
          tyreCondition={tyreCondition}
          setTyreCondition={setTyreCondition}
          tyreStatus={tyreStatus}
          setTyreStatus={setTyreStatus}
          isValid={isValid}
        />)}
        {processType === "Reefer" &&
         <ReeferFields toggles={toggles} handleToggleChange={handleToggleChange} />
        }
        {(processType !== "Tyre" || processType !== "Tire" || processType !== "Picture") && 
        (<div className="row g-3 align-item-center mt-1 mb-3">
          {processType === "Light" && 
          <div className={`col-md-6`}>
            <ToggleSwitch 
              label="Capture light type"
              labelStyle="ms-2 fw-600"
              checked={toggles.enableLightType}
              onChange={(value:any) => {handleToggleChange("enableLightType", value)}}/>
            <CreatableSelect
              isMulti
              options={[]}
              name="lightTypes"
              value={lightTypes}
              onChange={(selected:any) => setLightTypes(selected)}
              placeholder={"Enter Light Type..."}
              className="basic-multi-select "
              classNamePrefix="select"
              isDisabled={!toggles.enableLightType}
              styles={{
                control: (provided: any) => ({
                  ...provided,
                  minHeight: "42px",
                }),
              }}
              
            />
          <div className='mb-1'>{toggles.enableLightType && lightTypes.length === 0 ? (
              <small className="text-danger ms-2 fw-700">light Type is required</small>
            ) : toggles.enableLightType ? (
              <small className="ms-2 fst-italic">Press enter to add new option</small>
            ) : null}</div>
            {/* { toggles.enableLightType && */}
            <ToggleSwitch 
              label="Capture lights count"
              labelStyle="ms-2 fw-600"
              checked={toggles.enableLightTypeCount}
              onChange={(value :any) => handleToggleChange("enableLightTypeCount", value)}
              />
              {/* } */}
          </div>} 
        {["General", "Light", "Reefer", "CTPAT"].includes(processType) && 
          <StatusConfirmationFields 
            processType={processType}
            toggles={toggles}
            handleToggleChange={handleToggleChange}
            multiStatus={multiStatus}
            setMultiStatus={setMultiStatus}
            defaultStatus={defaultStatus}
          />
        }
          {processType === "Light" && 
          <>
          <div className={`col-md-6`}>
            <ToggleSwitch 
              label="Require Reflector Status Confirmation"
              labelStyle="ms-2 fw-600"
              checked={toggles.reflectorRequired}
              onChange={(value:any) => {handleToggleChange("reflectorRequired", value)}}/>
            <CreatableSelect
              isMulti
              options={[]}
              name="reflectorStatus"
              value={reflectorStatus}
              onChange={(selected:any) => setReflectorStatus(selected)}
              placeholder={"Enter Reflector Status..."}
              className="basic-multi-select "
              classNamePrefix="select"
              isDisabled={!toggles.reflectorRequired}
              styles={{
                control: (provided: any) => ({
                  ...provided,
                  minHeight: "42px",
                }),
              }}
            />
            {toggles.reflectorRequired && reflectorStatus.length === 0 ? (
              <small className="text-danger ms-2 fw-700">Reflector status is required</small>
            ) : null}
            </div>
            <div className={`col-md-6`} style={{paddingTop: "35px"}}>
              <ToggleSwitch 
                label="Capture Reflector count"
                labelStyle="ms-2 fw-600"
                checked={toggles.reflectorCountRequired}
                onChange={(value :any) => handleToggleChange("reflectorCountRequired", value)}
                />
            </div></>}
        </div>)}
    </div>
  )
}
export default ProcessTypeSpecific